import { Link } from 'react-router-dom';
import { House, MagnifyingGlass } from '@phosphor-icons/react';
import Logo from '../components/Logo';

export default function NotFound() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 to-blue-50/50 flex flex-col">
      <header className="bg-white/80 backdrop-blur-md border-b border-slate-200/60">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 h-14 flex items-center">
          <Logo linkTo="/" />
        </div>
      </header>

      <main className="flex-1 flex items-center justify-center px-6">
        <div className="text-center">
          <p className="text-7xl sm:text-8xl font-bold text-blue-600 mb-2">404</p>
          <h1 className="text-xl sm:text-2xl font-bold text-slate-800 mb-3">Pagina nao encontrada</h1>
          <p className="text-sm text-slate-400 mb-8 max-w-sm mx-auto">
            A pagina que voce esta procurando nao existe ou foi movida.
          </p>
          <div className="flex items-center justify-center gap-3">
            <Link
              to="/"
              className="flex items-center gap-2 bg-blue-600 text-white px-5 py-2.5 rounded-xl hover:bg-blue-700 transition text-sm font-medium"
            >
              <House size={16} />
              Inicio
            </Link>
            <Link
              to="/dashboard"
              className="flex items-center gap-2 bg-slate-100 text-slate-700 px-5 py-2.5 rounded-xl hover:bg-slate-200 transition text-sm font-medium"
            >
              <MagnifyingGlass size={16} />
              Dashboard
            </Link>
          </div>
        </div>
      </main>
    </div>
  );
}
